var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFB",
    d: "M18.451 0c-.626.795-1.07 1.751-1.259 2.817l-6.115 34.632c-.552 3.127 1.291 6.121 4.213 7.108l-2.746.632c-2.03.468-4.057-.796-4.525-2.824l-7.921-34.265c-.47-2.028.797-4.05 2.827-4.519l15.526-3.581Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CC2C24",
    points: "6.668 9.776 8.594 5.903 11.09 5.375 8.594 10.332 13.533 14.248 10.869 14.898 6.932 11.542 7.946 15.554 5.896 16.038 3.819 7.052 5.914 6.492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFB",
    d: "m24.1.208 22.782 4.011c2.052.362 3.422 2.316 3.06 4.365l-6.115 34.632c-.361 2.05-2.318 3.418-4.37 3.057l-22.781-4.012c-2.052-.361-3.422-2.315-3.06-4.365l6.114-34.632c.362-2.05 2.319-3.418 4.37-3.056Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "m26.722 3.143 3.22 10.874-2.028-.322-.548-1.85-3.716-.454-.968 1.477-2.123-.335 6.163-9.39Zm-.603 4.49-1.471 2.24 2.215.27-.744-2.51Zm11.923 36.409-3.221-10.875 2.029.322.548 1.848 3.714.456.97-1.477 2.123.335-6.163 9.39Zm.602-4.49 1.472-2.24-2.215-.271.743 2.51Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#282828",
    points: "33.6 12.372 38.024 28.328 32.633 27.378 33.878 31.866 27.048 30.663 29.644 26.851 24.363 25.923"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoker);
export default __webpack_public_path__ + "static/media/poker.ea4c5033b4f8db702c81ef63d4dbb7b4.svg";
export { ForwardRef as ReactComponent };